import { Colors } from '@unfold/theme';
import { IButtonTheme } from './types';

export const ButtonTheme: IButtonTheme = {
  bordered: {
    light: {
      backgroundColor: 'transparent',
      color: Colors.BLACK,
      border: `2px solid ${Colors.G500}`,
    },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.WHITE,
      border: `2px solid ${Colors.G100}`,
    },
  },
  default: {
    light: { backgroundColor: Colors.G600, color: Colors.G300 },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.WHITE,
      border: `1.4px solid ${Colors.G100}`,
    },
  },
  link: {
    light: { backgroundColor: 'transparent', color: Colors.B400 },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.B400,
    },
  },
  primary: {
    light: { backgroundColor: Colors.BLACK, color: Colors.WHITE },
    dark: {
      backgroundColor: Colors.DG100,
      color: Colors.WHITE,
    },
  },
  subtle: {
    light: {
      backgroundColor: 'transparent',
      color: Colors.BLACK,
      fontWeight: 500,
    },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.G300,
      fontWeight: 500,
    },
  },
  popover: {
    light: {
      backgroundColor: 'transparent',
      color: Colors.BLACK,
      fontWeight: 500
    },
    dark: {
      backgroundColor: 'transparent',
      color: Colors.G300,
      fontWeight: 500
    },
  },
};
